export default __webpack_public_path__ + "static/media/risk-evaluation.a18bdecc.svg";